module.exports = __webpack_public_path__ + "assets/img/operation.606f6afb.svg";